module.exports = __webpack_public_path__ + "img/kummer-von-der-seele-schreiben.22a0df25.jpg";